import type { MembroEquipe } from "@/mocks/projetos";

interface Props {
  membros: MembroEquipe[];
}

const funcaoConfig: Record<string, { icon: string; color: string }> = {
  "Responsável Técnico": { icon: "ri-user-star-line", color: "text-primary-600" },
  "Técnica de Campo": { icon: "ri-user-line", color: "text-accent-600" },
  "Técnico de Campo": { icon: "ri-user-line", color: "text-accent-600" },
  "Analista GIS": { icon: "ri-map-pin-line", color: "text-secondary-600" },
  "Fiscal": { icon: "ri-shield-check-line", color: "text-warning-600" },
  "Consultor Externo": { icon: "ri-user-voice-line", color: "text-caution-600" },
};

export default function ProjectTeamCards({ membros }: Props) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {membros.map((membro, i) => {
          const cfg = funcaoConfig[membro.funcao] || { icon: "ri-user-line", color: "text-foreground-400" };
          const initials = membro.nome.split(" ").map((n) => n[0]).join("").slice(0, 2);
          const isLider = membro.funcao === "Responsável Técnico";
          const isInativo = membro.status === "inativo";
          return (
            <div
              key={i}
              className={`bg-white rounded-card border ${
                isLider ? "border-primary-300" : "border-background-200"
              } p-4 hover:border-background-300 transition-colors ${isInativo ? "opacity-60" : ""}`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
                  isLider ? "bg-primary-100" : "bg-background-100"
                }`}>
                  <span className={`text-sm font-bold ${isLider ? "text-primary-700" : "text-foreground-600"}`}>
                    {initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="text-sm font-semibold text-foreground-900">{membro.nome}</p>
                    {isLider && <span className="badge bg-primary-100 text-primary-700 text-[10px]">Líder</span>}
                    {isInativo && <span className="badge bg-background-100 text-foreground-500 text-[10px]">Inativo</span>}
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{membro.funcao}</p>
                </div>
              </div>

              <div className="mt-3 pt-3 border-t border-background-200 space-y-1.5">
                <div className="flex items-center gap-1.5">
                  <i className="ri-mail-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-600 truncate">{membro.email}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-phone-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-600">{membro.telefone}</span>
                </div>
              </div>

              <div className="mt-3 grid grid-cols-2 gap-2">
                <div className="bg-background-50 rounded-lg p-2 text-center">
                  <p className="text-sm font-bold text-foreground-900 tabular-nums">{membro.cadastros.toLocaleString("pt-BR")}</p>
                  <p className="text-[10px] text-foreground-500">Cadastros</p>
                </div>
                <div className="bg-background-50 rounded-lg p-2 text-center">
                  <p className="text-sm font-bold text-foreground-900 tabular-nums">{membro.vistorias.toLocaleString("pt-BR")}</p>
                  <p className="text-[10px] text-foreground-500">Vistorias</p>
                </div>
              </div>
            </div>
          );
        })}

        {/* Add member button */}
        <button className="flex flex-col items-center justify-center gap-2 p-4 rounded-card border-2 border-dashed border-background-300 hover:border-primary-400 hover:bg-primary-50/50 transition-colors cursor-pointer min-h-[200px]">
          <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
            <i className="ri-add-line text-primary-500 text-lg"></i>
          </div>
          <span className="text-sm text-primary-600 font-medium">Adicionar Membro</span>
        </button>
      </div>
    </div>
  );
}